import { typedBoolean } from "../helper";
export const transTextConversion = (keys) => [...(keys || [])].filter(typedBoolean).map((item) => ({
    initValue: item.init_value || "",
    convertedValue: item.converted_value || "",
}));
